import api from './api';

/**
 * Serviço de Notificações do Frontend
 * Gerencia as chamadas à API de notificações
 */
const notificacaoService = {
  /**
   * Listar notificações com filtros e paginação
   * @param {Object} params - Parâmetros de filtro
   * @param {number} params.page - Número da página
   * @param {number} params.limit - Limite por página
   * @param {string} params.tipo - Tipo de notificação
   * @param {string} params.modulo - Módulo de origem
   * @param {boolean} params.apenasNaoLidas - Filtrar apenas não lidas
   * @param {string} params.prioridade - Prioridade
   * @param {string} params.dataInicio - Data inicial
   * @param {string} params.dataFim - Data final
   * @param {number} params.extensaoId - ID da extensão
   */
  async listar(params = {}) {
    try {
      const response = await api.get('/notificacoes', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar notificações:', error);
      throw error;
    }
  },

  /**
   * Contar notificações não lidas
   */
  async contarNaoLidas() {
    try {
      const response = await api.get('/notificacoes/count');
      return response.data;
    } catch (error) {
      console.error('Erro ao contar notificações:', error);
      throw error;
    }
  },

  /**
   * Buscar resumo de notificações para dashboard
   */
  async obterResumo() {
    try {
      const response = await api.get('/notificacoes/resumo');
      return response.data;
    } catch (error) {
      console.error('Erro ao obter resumo de notificações:', error);
      throw error;
    }
  },

  /**
   * Buscar notificação por ID
   * @param {number} id - ID da notificação
   */
  async buscarPorId(id) {
    try {
      const response = await api.get(`/notificacoes/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar notificação:', error);
      throw error;
    }
  },

  /**
   * Buscar quem visualizou uma notificação
   * @param {number} id - ID da notificação
   */
  async buscarVisualizadores(id) {
    try {
      const response = await api.get(`/notificacoes/${id}/visualizadores`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar visualizadores:', error);
      throw error;
    }
  },

  /**
   * Marcar notificação como visualizada
   * @param {number} id - ID da notificação
   */
  async marcarComoVisualizada(id) {
    try {
      const response = await api.post(`/notificacoes/${id}/visualizar`);
      return response.data;
    } catch (error) {
      console.error('Erro ao marcar notificação como visualizada:', error);
      throw error;
    }
  },

  /**
   * Marcar múltiplas notificações como visualizadas
   * @param {number[]} ids - IDs das notificações
   */
  async marcarMultiplasComoVisualizadas(ids) {
    try {
      const response = await api.post('/notificacoes/visualizar-multiplas', { ids });
      return response.data;
    } catch (error) {
      console.error('Erro ao marcar notificações como visualizadas:', error);
      throw error;
    }
  },

  /**
   * Marcar todas as notificações como visualizadas
   */
  async marcarTodasComoVisualizadas() {
    try {
      const response = await api.post('/notificacoes/visualizar-todas');
      return response.data;
    } catch (error) {
      console.error('Erro ao marcar todas as notificações:', error);
      throw error;
    }
  },

  /**
   * Deletar notificação (apenas admins)
   * @param {number} id - ID da notificação
   */
  async deletar(id) {
    try {
      const response = await api.delete(`/notificacoes/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar notificação:', error);
      throw error;
    }
  },

  /**
   * Buscar tipos de notificação disponíveis
   */
  async buscarTipos() {
    try {
      const response = await api.get('/notificacoes/tipos');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar tipos de notificação:', error);
      throw error;
    }
  }
};

export default notificacaoService;
